import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import { getFulfillmentOrderDetailsApi } from './getFulfillmentOrderDetails.api'
import {
  GetFulfillmentOrderDetailsRequest,
  GetFulfillmentOrderDetailsSuccessResponse
} from './getFulfillmentOrderDetails.types'

export const getFulfillmentOrderDetails = createAsyncThunk(
  urls.fulfillmentOrders.getFulfillmentOrderDetails,
  async (request: GetFulfillmentOrderDetailsRequest) => {
    return await getFulfillmentOrderDetailsApi(request)
  }
)

interface GetFulfillmentOrderDetailsState {
  loading: boolean
  success: GetFulfillmentOrderDetailsSuccessResponse | null
  error: string | null
}

const initialState: GetFulfillmentOrderDetailsState = {
  loading: false,
  success: null,
  error: null
}

const getFulfillmentOrderDetailsSlice = createSlice({
  name: urls.fulfillmentOrders.getFulfillmentOrderDetails,
  initialState,
  reducers: {
    resetGetFulfillmentOrderDetails: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFulfillmentOrderDetails.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getFulfillmentOrderDetails.fulfilled, (state, action) => {
        state.loading = false
        state.success = action.payload
      })
      .addCase(getFulfillmentOrderDetails.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch order details'
      })
  }
})

export const { resetGetFulfillmentOrderDetails } = getFulfillmentOrderDetailsSlice.actions
export default getFulfillmentOrderDetailsSlice.reducer
